import SubscriptionPlanInformation from "./SubscriptionPlanInformation";
import SubscriptionConfirmationActionFooter from "./SubscriptionConfirmationActionFooter";
import { RootState } from "store/store";
import ProductLicense from "interfaces/response/ProductLicense";
import { useSelector } from "react-redux";
import { getCurrentProductSubscriptionDetail } from "shared/utility/ProductSubscriptionHelper";
import moment from "moment";

interface Props {
  defaultFreeLicense: ProductLicense;
  onCancel?: () => void;
  onApply?: () => void;
}

export default function CancelSubscriptionConfirmation(props: Props) {
  const { defaultFreeLicense, onCancel, onApply } = props;

  const currentSubscriptionDetail = useSelector((state: RootState) =>
    getCurrentProductSubscriptionDetail(state)
  );

  const ActionFooter = () => {
    return (
      <SubscriptionConfirmationActionFooter
        onCancel={onCancel}
        onApply={onApply}
        applyButtonCaption="Confirm"
      />
    );
  };

  const getFormattedPeriodStartDate = () => {
    return moment(currentSubscriptionDetail?.currentPeriodFinish).format(
      "DD MMMM YYYY"
    );
  };

  return (
    <>
      <SubscriptionPlanInformation
        title="Cancel subscription plan"
        planDetail={{
          actions: defaultFreeLicense.numberOfAllowedActions || 0,
          price: "Free",
          starts: getFormattedPeriodStartDate(),
        }}
        description={{
          title: "Current plan runs until next billing cycle",
          detailComponent: (
            <>
              <p>
                Your free plan starts at the end of the current billing cycle:
              </p>
              <p className="italic">{getFormattedPeriodStartDate()}</p>
            </>
          ),
        }}
      />
      <>
        <ActionFooter />
      </>
    </>
  );
}
